import { AxiosError } from 'axios';
import Cookies from 'js-cookie';

import RepositoryFactory from '@/repository/RepositoryFactory';
import { HTTP_STATUS, HTTP_STATUS_MESSAGE } from '@/constant';

/**
 * APIエラー発生時の共通のエラーハンドリング
 * @param response APIのレスポンス
 * @param angularActions AngularJSのnotify(angular-notify.js),scope
 */
export const showErrorNotification = async function (axiosError: AxiosError, angularActions: any) {
  const { notify, state } = angularActions;
  const { response } = axiosError;
  const status = response ? response.status : null;

  let message = HTTP_STATUS_MESSAGE.DEFAULT;

  switch (status) {
    case HTTP_STATUS.FORBIDDEN:
      message = HTTP_STATUS_MESSAGE.FORBIDDEN;
      break;

    case HTTP_STATUS.NOT_FOUND:
      message = HTTP_STATUS_MESSAGE.NOT_FOUND;
      break;

    case HTTP_STATUS.LEGAL_REASONS:
      message = HTTP_STATUS_MESSAGE.LEGAL_REASONS;
      break;

    default:
      break;
  }

  notify({
    duration: 6000,
    position: 'right',
    message,
    classes: 'alert-danger2',
  });
};
